var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirroringSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.3457031,4,1,5.3457031,1,7v7h2V7c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1v18 c0,0.5517578-0.4482422,1-1,1H15v2h13c1.6542969,0,3-1.3457031,3-3V7C31,5.3457031,29.6542969,4,28,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,16v2c5.5136719,0,10,4.4863281,10,10h2C13,21.3828125,7.6171875,16,1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,20v2c3.3085938,0,6,2.6914062,6,6h2C9,23.5888672,5.4111328,20,1,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,24v2c1.1025391,0,2,0.8974609,2,2h2C5,25.7939453,3.2060547,24,1,24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirroringSmall);
export default __webpack_public_path__ + "static/media/mirroring--small.0068416ba4621aa6fd2069335a827cf2.svg";
export { ForwardRef as ReactComponent };